// extracted by mini-css-extract-plugin
export default {"image":"r2-z","loaded":"s2-z"};